import "./KakiMakanMobile.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ThumbnailCard from "@components/Blocks/Card/Thumbnail/ThumbnailCard";
import VideoPlayerSticky from "@elements/Player/VideoPlayerSticky";
import { LatestVideoResponse } from "@hooks/transformer/useBrightcoveResponse";
import { ReactElement, RefObject, useState } from "react";
import Slider from "react-slick";

type KakiMakanMobileVideoProps = {
  containerRef: RefObject<HTMLDivElement>;
  videos: LatestVideoResponse[];
  handleOnEndedVideo: () => void;
  handleOnClickThumbnail: (props: LatestVideoResponse) => void;
  playing?: LatestVideoResponse;
};

/**
 * KakiMakanMobileVideo
 * Description: [Renders kaki makan videos for mobile view]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function KakiMakanMobileVideo({
  containerRef,
  videos,
  handleOnEndedVideo,
  handleOnClickThumbnail,
  playing,
}: KakiMakanMobileVideoProps): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const SliderComponent =
    // @ts-expect-error @typescript-eslint/no-unsafe-assignment
    typeof window === "undefined" ? Slider.default : Slider;

  const [activeSlide, setActiveSlide] = useState<number>(0);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    centerMode: false,
    beforeChange: (_current: number, next: number) => {
      setActiveSlide(next);
    },
    appendDots: (dots: React.ReactNode) => (
      <div style={{ bottom: "-22px" }}>
        <ul className="flex justify-center gap-2">{dots}</ul>
      </div>
    ),
    customPaging: (i: number) => {
      const isActive = i === activeSlide;
      return (
        <div
          className="rounded-[50px] transition-all"
          style={{
            width: "8px",
            height: "8px",
            background: isActive ? "#01519c" : "#e1e1e1",
          }}
        />
      );
    },
  };

  return (
    <div className="flex flex-col mb-8">
      <SliderComponent {...settings}>
        {videos.map((video, index) => (
          <div
            id={`video-slide-${video.id}`}
            key={video.id}
            className="min-w-[300px]"
          >
            {playing?.id === video.id ? (
              <VideoPlayerSticky
                playing={playing}
                forwadedRef={containerRef}
                onEnded={handleOnEndedVideo}
                nextPlaylist={handleOnEndedVideo}
                showDescription={false}
                variant="kaki_makan_page"
              />
            ) : (
              <ThumbnailCard<LatestVideoResponse>
                testId={`video-kaki-makan-mobile-${index}`}
                handleOnClickThumbnail={handleOnClickThumbnail}
                variant="kaki_makan_page"
                {...video}
              />
            )}
          </div>
        ))}
      </SliderComponent>
    </div>
  );
}
